import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class LoaderService{

  public _isLoading:boolean = false;

  constructor(){

  }

  start(){
    this._isLoading = true;
  }

  end(){
    this._isLoading = false;
  }

  get isLoading(){
    return this.isLoading;
  }

}
